import React from 'react'
import { Accordion } from '@mc/design-system'

export const FaqSection = ({
  title,
  children,
}: {
  title: string
  children: React.ReactNode
}) => (
  <Accordion.Section className='mc-mt-9' label={title}>
    {children}
  </Accordion.Section>
)
